import { render, staticRenderFns } from "./about-main.vue?vue&type=template&id=7bc271cf&scoped=true&"
import script from "./about-main.vue?vue&type=script&lang=js&"
export * from "./about-main.vue?vue&type=script&lang=js&"
import style0 from "./about-main.vue?vue&type=style&index=0&id=7bc271cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc271cf",
  null
  
)

export default component.exports